const Style = `
  <style>
    .accordion-advanced-header {
      cursor: pointer;
      display: flex;
      align-items: center;
    }

    .accordion-advanced-header .accordion-arrow-down {
      top: 12px;
      display: none;
    }

    .accordion-advanced-header.active .accordion-arrow-right {
      display: none;
    }

    .accordion-advanced-header.active .accordion-arrow-down {
      display: flex;
      transform: rotate(180deg);
    }

    .accordion-arrow-icon {
      display: flex;
      transform: rotate(90deg);
    }
  </style>
`;

export default Style;
